<div class="filtro-busca-wrapper">
  <input
    type="text"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    [placeholder]="placeholder"
    [disabled]="disabled"
  />
</div>
